import * as tslib_1 from "tslib";
import { takeLatest, put } from "redux-saga/effects";
import { ERROR_PRELOAD_APP } from "../actions/app";
function startLoadingApp() {
    return function (options) {
        var action;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = { type: ERROR_PRELOAD_APP, options: options };
                    return [4 /*yield*/, put(action)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
}
export function startLoadingAppWatcher() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ERROR_PRELOAD_APP, startLoadingApp())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default [
    startLoadingAppWatcher(),
];



//////////////////
// WEBPACK FOOTER
// ./src/sagas/app.ts
// module id = 268
// module chunks = 0